import { Grid } from '@mui/material';
import CourseInfoItem from './CourseInfoItem';
import { convertDayCodesToFullNames } from '../../common/utils';
import dayjs from 'dayjs';

export default function CourseInfo({ id, course }) {
  const daysFullName = convertDayCodesToFullNames(course.MEETING_DAYS);
  const startTime = dayjs(course?.BEGIN_TIME, 'HH:mm').format('h:mm A');
  const endTime = dayjs(course?.END_TIME, 'HH:mm').format('h:mm A');

  const getLocation = () => {
    let location = '';
    if (course.BUILDING_CODE) {
      location = course.BUILDING_CODE;
    }
    if (course.ROOM_CODE) {
      location = location ? `${location} - ${course.ROOM_CODE}` : course.ROOM_CODE;
    }
    if (!location) {
      location = '-';
    }

    return location;
  };

  return (
    <Grid container id={`${id}__grid_container`} spacing={2} mt={2}>
      <Grid item id={`${id}__grid_item_instructorName`} xs={12} xl={3}>
        <CourseInfoItem
          id={`${id}InstructorName`}
          label="Primary Instructor"
          value={course.INSTRUCTOR_NAME}
        />
      </Grid>
      <Grid item id={`${id}__grid_item_instructorEmail`} xs={12} xl={3}>
        <CourseInfoItem
          id={`${id}InstructorEmail`}
          label="Primary Instructor Email"
          value={course.INSTRUCTOR_EMAIL}
        />
      </Grid>
      <Grid item xs={12} xl={3} id={`${id}__grid_item_otherInstructors`}>
        <CourseInfoItem
          id={`${id}OtherInstructors`}
          label="Other Instructors"
          value={course.OTHER_INSTRUCTORS}
        />
      </Grid>
      <Grid item xs={12} xl={3} id={`${id}__grid_item_location`}>
        <CourseInfoItem id={`${id}Location`} label="Location" value={getLocation()} />
      </Grid>
      <Grid item xs={12} xl={3} id={`${id}__grid_item_meetingTime`}>
        <CourseInfoItem
          id={`${id}MeetingTime`}
          label="Meeting"
          value={`${daysFullName} ${startTime} - ${endTime}`}
        />
      </Grid>
      <Grid item xs={12} xl={3} id={`${id}__grid_item_startDate`}>
        <CourseInfoItem label="Start Date" value={course.START_DATE} id={`${id}StartDate`} />
      </Grid>
      <Grid item xs={12} xl={3} id={`${id}__grid_item_endDate`}>
        <CourseInfoItem label="End Date" value={course.END_DATE} id={`${id}EndDate`} />
      </Grid>
    </Grid>
  );
}
